// extracted by mini-css-extract-plugin
export var chevron = "_lg-4";
export var chevronExpanded = "_lg-5";
export var row = "_lg-0";
export var rowBody = "_lg-6";
export var rowDescription = "_lg-7";
export var rowHeader = "_lg-1";
export var rowTitle = "_lg-2";
export var rowTitleComplete = "_lg-3";